import React, { useRef } from 'react'
import { TouchableOpacity, View, TextInput as RNTextInput } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Button, ScreenAuth, Text, TextInput, ButtonSocialGroup } from '@components'
import { ScreenAuthProps } from '@navigation'
import { useLanguage } from '@context'
import { useRegister } from './hook'
import getStyle from './style'
import { useScreen, useSocialAuth } from '@hooks'
import { getCommonStyles } from '@utils'

export const Register: React.FC<ScreenAuthProps<'Register'>> = ({ navigation }) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const { isMobile } = useScreen()
  const styles = getStyle(theme)
  const commonStyles = getCommonStyles(theme)

  const {
    email,
    password,
    confirmPassword,
    isPending,
    error,
    fieldErrors,
    setEmail,
    setPassword,
    setConfirmPassword,
    handleSignUp,
  } = useRegister(navigation)
  const { signInWithGoogle, signInWithApple, signInWithFacebook, signInWithLinkedIn } = useSocialAuth()

  const passwordRef = useRef<RNTextInput>(null)
  const confirmPasswordRef = useRef<RNTextInput>(null)

  return (
    <ScreenAuth title={t('register.title')} isPending={isPending}>
      <View style={[styles.container, !isMobile && commonStyles.flexMaxAuth]}>
        <View>
          <TextInput
            placeholder={t('register.email')}
            value={email}
            onChangeText={setEmail}
            containerStyle={styles.emailInput}
            autoCapitalize={'none'}
            iconRight="message"
            hasError={!!fieldErrors.email}
            onSubmitEditing={() => passwordRef.current?.focus()}
          />
          <TextInput
            currentRef={passwordRef}
            placeholder={t('register.password')}
            value={password}
            onChangeText={setPassword}
            containerStyle={styles.passwordInput}
            secureTextEntry={true}
            iconRight="eye"
            hasError={!!fieldErrors.password}
            onSubmitEditing={() => confirmPasswordRef.current?.focus()}
          />
          <TextInput
            currentRef={confirmPasswordRef}
            placeholder={t('register.confirmPassword')}
            value={confirmPassword}
            onChangeText={setConfirmPassword}
            secureTextEntry={true}
            iconRight="eye"
            hasError={!!fieldErrors.confirmPassword}
            onSubmitEditing={handleSignUp}
          />
          {!!error && (
            <Text type="bodyExtraSmall" color={theme.colors.error} style={styles.noAccount}>
              {error}
            </Text>
          )}
        </View>

        <View style={styles.buttonContainer}>
          <Button title={t('register.button')} onPress={handleSignUp} />
          <TouchableOpacity onPress={() => navigation.navigate('Login')}>
            <Text type="bodyExtraSmall" color={theme.colors.black} style={styles.noAccount}>
              {t('register.haveAccount')}
            </Text>
          </TouchableOpacity>
          <ButtonSocialGroup
            title={t('register.or')}
            onPressFacebook={signInWithFacebook}
            onPressGoogle={signInWithGoogle}
            onPressApple={signInWithApple}
            onPressLinkedin={signInWithLinkedIn}
          />
        </View>
      </View>
    </ScreenAuth>
  )
}
